import React, { useState } from "react";

import RadioItem from "./radioItem";

const RadioWithChild = (props) => {
  const { onChange, options, _crengine, dataBind, ...rest } = props;

  const getCheckedValue = () => {
    if (props.value) {
      return props.value;
    }
    if (props.initialValue) {
      return props.initialValue;
    }
    return null;
  };

  const parentValue = getCheckedValue()

  const [value, setValue] = useState<object>(parentValue);

  if (!(options && Array.isArray(options) && options.length)) {
    return null;
  }

  const onComponentChange = data => {
    onChange(data);
    setValue(data);
  };

  return (
    <div {...rest}>
      {options.map(item => {
        return (
          <RadioItem
            {...item}
            _crengine={_crengine}
            dataBind={dataBind}
            key={item.value}
            checkedValue={value}
            onChange={data => onComponentChange(data)}
          />
        );
      })}
    </div>
  );
};

export default RadioWithChild;
